import PropTypes from 'prop-types';
import { Form, Button, Card, Row, Col, ProgressBar } from 'react-bootstrap';

async function verhognoreunificados() {
    const tdcantHogaresReunif = document.getElementById('tdcanthogaresnoreunif').textContent;
    alert(`Cantidad de hogares que requieren Reunificacion Familiar: ${tdcantHogaresReunif}`);
}

function ReporteReunificacion({ dataReunificacion }) {
    return (
        <Card>
            <Card.Header>
                <h3>Derecho a la Reunificaci&oacute;n</h3>
            </Card.Header>
            <Card.Body>
                <div className="row">
                    <div className="col-md-8">
                        <div className="box">
                        <div className="box-header">
                            <h3 className="box-title">Derecho a la Reunificacion</h3>
                        </div>
                        <div className="box-body no-padding">
                            <table className="table table-condensed">
                            <tbody>
                            <tr>
                                <th style={{ backgroundColor: '#F0F1EF' }}></th>
                                <th style={{ backgroundColor: '#F0F1EF' }}>Cantidad</th>
                                <th style={{ backgroundColor: '#F0F1EF' }}>Porcentaje</th>
                            </tr>
                            <tr>
                                <td>Total hogares</td>
                                <td className="thdcenter"><span id="tdcanthogares">{dataReunificacion.tdcanthogares}</span></td>
                                <td className="thdcenter"><span id="tdporccanthogares" className="badge bg-blue">{dataReunificacion.tdporccanthogares}</span></td>  
                            </tr>
                            <tr>
                                <td><button style={{ color: 'green', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline' }}>Hogares no requieren Reunificacion Familiar</button></td>
                                <td className="thdcenter"><span id="tdtotcanthogaresReunif">{dataReunificacion.tdtotcanthogaresReunif}</span></td>
                                <td className="thdcenter"><span id="tdporccanthogaresReunif" className="badge bg-green">{dataReunificacion.tdporccanthogaresReunif}</span></td>  
                            </tr>
                            <tr>
                                <td><button style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer', padding: 0, textDecoration: 'underline' }} onClick={verhognoreunificados}>Hogares requieren Reunificacion Familiar</button></td>
                                <td className="thdcenter"><span id="tdcanthogaresnoreunif">{dataReunificacion.tdcanthogaresnoreunif}</span></td>
                                <td className="thdcenter"><span id="tdporccanthogaresnoreunif" className="badge bg-red">{dataReunificacion.tdporccanthogaresnoreunif}</span></td>  
                            </tr>
                            </tbody></table>
                            <hr/>
                        </div>
                        </div>
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
}

ReporteReunificacion.propTypes = {
    dataReunificacion: PropTypes.object.isRequired,
};

export default ReporteReunificacion;